export const FeaturedBrands = [
  {
    src: "https://images-static.nykaa.com/creatives/8cf2ef90-37c9-4bde-95f0-f33c23472dab/default.jpg?tr=w-480,cm-pad_resize",
    text: "Up To 25% Off",
    disc: "Free Sunblock On 899",
  },
  {
    src: "https://images-static.nykaa.com/creatives/17376df9-ac03-42df-a7ad-25b7fa58a34d/default.png?tr=w-480,cm-pad_resize",
    text: "Min 20% Off",
    disc: "Serum of 799 on 799",
  },
  {
    src: "https://images-static.nykaa.com/creatives/533cddc6-1f27-4cb6-881d-2473bc89d5ac/default.jpg?tr=w-480,cm-pad_resize",
    text: "Flat10% Off",
    disc: "2 Gifts on ₹3000 ",
  },
  {
    src: "https://images-static.nykaa.com/creatives/9ece2199-1993-4f3d-b85d-8924e7494f60/default.jpg?tr=w-480,cm-pad_resize",
    text: "Up To 25% Off",
    disc: "On Entire Range",
  },
  {
    src: "https://images-static.nykaa.com/creatives/636dcfea-09f8-4d5d-b2b3-407df3ab18bc/default.jpg?tr=w-480,cm-pad_resize",
    text: "Up To 25% Off",
    disc: "Free Kajal on ₹699+",
  },
  {
    src: "https://images-static.nykaa.com/creatives/b281fd98-075d-415f-b28b-148ba6184324/default.png?tr=w-480,cm-pad_resize",
    text: "25% Off Combos",
    disc: "Haircare Bestsellers",
  },
  {
    src: "https://images-static.nykaa.com/creatives/890005b6-74b6-45f2-bafc-fd5c53807a6f/default.jpg?tr=w-480,cm-pad_resize",
    text: "Flat 10% Off",
    disc: "On The Entire Range",
  },
  {
    src: "https://images-static.nykaa.com/creatives/f1e07044-14a3-4de4-a23e-57307a7d8941/default.jpg?tr=w-480,cm-pad_resize",
    text: "Up To 35% Off",
    disc: "On Entire Range",
  },
  {
    src: "https://images-static.nykaa.com/creatives/d439ba1f-48a3-493f-ab9d-420ac82220af/default.jpg?tr=w-480,cm-pad_resize",
    text: "Min 20% Off",
    disc: "Free Eyeliner on 699",
  },
  {
    src: "https://images-static.nykaa.com/creatives/18888525-a188-4003-af9d-e778eb1e5d63/default.jpg?tr=w-480,cm-pad_resize",
    text: "on ₹1100",
    disc: "Gifts Worth ₹1050",
  },
];


export const afterFeatureBrand = [
  {
    src: "https://images-static.nykaa.com/creatives/b211ab74-f311-408c-922f-2bed0f6f1bdf/default.jpg?tr=w-800,cm-pad_resize",
    text: "Up To 40% Off",
    disc: "Just in Vitamin Rich Goji Berry",
  },
  {
    src: "https://images-static.nykaa.com/creatives/272f6793-2392-44e4-8c4e-85cfd33e4611/default.jpg?tr=w-800,cm-pad_resize",
    text: "Min 20% Off",
    disc: "Free Liquid Lipstick on 499+",
  },
  {
    src: "https://images-static.nykaa.com/creatives/61f1866f-af96-452c-95b6-c4b079e99a5a/default.jpg?tr=w-800,cm-pad_resize",
    text: "Minimum 15% off",
    disc: "On Bestselling Korean Skincare!",
  },
];